import React, { useContext } from 'react';
import { PropTypes } from 'prop-types';
import { Grid } from '@material-ui/core';
import { CalendarInput, ClinicInput, FlatSelect } from '../../../../UI';
import MessagesContext from '../../../../../contexts/messagesContext';

export const GENDERS = [
    { label: 'male', value: 'M' },
    { label: 'female', value: 'F' }
];

export const MARITAL_STATUSES = [
    { label: 'single', value: 'S' },
    { label: 'married', value: 'M' }
];

const HeaderForm = ({ values, setValues }) => {
    const { messages } = useContext(MessagesContext);

    const setFieldValue = (name, value) => {
        setValues({ ...values, [name]: value });
    };

    return (
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <ClinicInput width="100%" name="title" label={messages.formTitle} type="text" />
            </Grid>
            <Grid item md={3}>
                <ClinicInput
                    width="100%"
                    name="admission_id"
                    label={messages.unitNumber}
                    type="text"
                />
            </Grid>
            <Grid item md={3}>
                <ClinicInput width="100%" name="national_id" label={messages.NID} type="text" />
            </Grid>
            <Grid item md={3}>
                <ClinicInput width="100%" name="last_name" label={messages.lastName} type="text" />
            </Grid>
            <Grid item md={3}>
                <ClinicInput width="100%" name="first_name" label={messages.name} type="text" />
            </Grid>
            <Grid item md={3}>
                <ClinicInput width="100%" name="ward" label={messages.ward} type="text" />
            </Grid>
            <Grid item md={3}>
                <ClinicInput width="100%" name="room" label={messages.room} type="text" />
            </Grid>
            <Grid item md={3}>
                <ClinicInput width="100%" name="bed" label={messages.bed} type="text" />
            </Grid>
            <Grid item md={3}>
                <ClinicInput
                    width="100%"
                    name="attendingPhysician"
                    label={messages.attendingPhysician}
                    type="text"
                />
            </Grid>
            <Grid item md={3}>
                <CalendarInput
                    width="100%"
                    label={messages.admissionDate}
                    name="admissionDate"
                    type="text"
                    value={values.admissionDate ? values.admissionDate : undefined}
                    setValue={(value) => setFieldValue('admissionDate', value)}
                />
            </Grid>
            <Grid item md={3}>
                <ClinicInput
                    width="100%"
                    name="fatherName"
                    label={messages.fatherName}
                    type="text"
                />
            </Grid>
            <Grid item md={3}>
                <CalendarInput
                    width="100%"
                    label={messages.birthDate}
                    name="birthDate"
                    type="text"
                    value={values.birthDate ? values.birthDate : undefined}
                    setValue={(value) => setFieldValue('birthDate', value)}
                />
            </Grid>
            <Grid item md={3}>
                <FlatSelect
                    isGender
                    options={GENDERS}
                    selected={values.gender}
                    label={messages.gender}
                    name="gender"
                    handleSelect={(e) => setFieldValue('gender', e)}
                />
            </Grid>
            <Grid item md={3}>
                <FlatSelect
                    isGender
                    options={MARITAL_STATUSES}
                    selected={values.maritalStatus}
                    label={messages.maritalStatus}
                    name="maritalStatus"
                    handleSelect={(e) => setFieldValue('maritalStatus', e)}
                />
            </Grid>
            <Grid item md={3}>
                <ClinicInput
                    width="100%"
                    name="occupation"
                    label={messages.occupation}
                    type="text"
                />
            </Grid>
            <Grid item md={3}>
                <CalendarInput
                    width="100%"
                    label={messages.dischargDate}
                    name="dischargDate"
                    type="text"
                    value={values.dischargDate ? values.dischargDate : undefined}
                    setValue={(value) => setFieldValue('dischargDate', value)}
                />
            </Grid>
        </Grid>
    );
};

HeaderForm.propTypes = {
    values: PropTypes.object,
    setValues: PropTypes.fun
};

export default HeaderForm;
